import { render, staticRenderFns } from "./ArtDetails.vue?vue&type=template&id=0c0d5c22&scoped=true&"
import script from "./ArtDetails.vue?vue&type=script&lang=ts&"
export * from "./ArtDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ArtDetails.vue?vue&type=style&index=0&id=0c0d5c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0d5c22",
  null
  
)

export default component.exports